import {
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { deepOrange } from "@mui/material/colors";
import { dateToStringLongSuffix } from "../../../common/utils/dateTime";
import { ObligationResponsePreviewDto } from "../../../interfaces/Obligation";
import _ from "lodash";
import { UserType } from "../../../common/interfaces/enums/UserType";

type ObligationResponseProps = {
  model?: ObligationResponsePreviewDto;
};

export default function ObligationResponse({ model }: ObligationResponseProps) {
  const render = () => (
    <Stack rowGap={4}>
      <Grid container spacing={1}>
        <Grid item xs={12} textAlign="center">
          <Typography variant="h5" fontStyle="oblique">
            Справка за наличие или липса на задължения за целите на чл. 264 от ДОПК към
          </Typography>
        </Grid>
        <Grid item xs={12} marginBottom={3} textAlign="center">
          <Typography fontSize={18} fontStyle="oblique">
            {dateToStringLongSuffix(model?.reportDate)}
          </Typography>
        </Grid>
        <Grid item xs={12} md={5} lg={3}>
          Идентификатор на ЗЛ:
        </Grid>
        <Grid item xs={12} md={7} lg={9}>
          <strong>
            {model?.taxpayerPinType}: {model?.taxpayerPin}
          </strong>
        </Grid>

        <Grid item xs={12} md={5} lg={3}>
          Име / наименование на ЗЛ:
        </Grid>
        <Grid item xs={12} md={7} lg={9}>
          <strong>{model?.taxpayerName}</strong>
        </Grid>

        <Grid item xs={12} md={5} lg={3}>
          Публичен изпълнител:
        </Grid>
        <Grid item xs={12} md={7} lg={9}>
          <strong>{model?.publicExecutor === "" ? "-" : model?.publicExecutor}</strong>
        </Grid>

        <Grid item xs={12} md={5} lg={3}>
          Извършил справката:
        </Grid>
        <Grid item xs={12} md={7} lg={9}>
          <Typography>
            {model?.userType === UserType.NotaryDeputy && <>пом. </>}
            нотариус <strong>{model?.userName}</strong>, номер{" "}
            <strong>{_.padStart(model?.notaryNumber?.toString(), 3, "0")}</strong>
          </Typography>
        </Grid>

        <Grid item xs={12} md={5} lg={3}>
          Основание за проверката:
        </Grid>
        <Grid item xs={12} md={7} lg={9}>
          <strong>{model?.documentType}</strong>
        </Grid>
      </Grid>

      <TableContainer>
        <Table sx={{ minWidth: 800 }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ whiteSpace: "nowrap", textAlign: "start" }}>Вид задължение</TableCell>
              <TableCell>IBAN</TableCell>
              <TableCell sx={{ textAlign: "end" }}>Размер на задължението</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {model?.obligations.map((item) => (
              <>
                {item.amount > 0 && (
                  <TableRow sx={{ backgroundColor: deepOrange[50] }} key={item.iban}>
                    <TableCell align="left">{item.obligationType}</TableCell>
                    <TableCell>{item.iban}</TableCell>
                    <TableCell sx={{ textAlign: "end" }}>{item.amount}</TableCell>
                  </TableRow>
                )}
                {item.amount === 0 && (
                  <TableRow hover key={item.iban}>
                    <TableCell align="left">{item.obligationType}</TableCell>
                    <TableCell>{item.iban}</TableCell>
                    <TableCell sx={{ textAlign: "end" }}>{item.amount}</TableCell>
                  </TableRow>
                )}
              </>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  );

  return model ? render() : null;
}
